import { colors } from '../styles/constants';

export const getBackground = ({
  primary, secondary, disabled, destructive, subtle, backgroundColor
}) => {
  if (disabled && primary) return colors.border;
  if (destructive) return colors.red;
  if (primary) return colors.brand;
  if (secondary) return colors.brandSecondary;
  if (subtle) return 'transparent';
  if (backgroundColor) return backgroundColor;
  return colors.white;
};

export const getTextcolor = ({
  primary, secondary, muted, disabled, destructive,
}) => {
  if (disabled && primary) return colors.lightText;
  if (primary || secondary || destructive) return colors.white;
  if (disabled) return colors.lightText;
  if (muted) return colors.mutedText;
  return colors.brand;
};

export const getBordercolor = ({
  primary, secondary, disabled, destructive, subtle,
}) => {
  if (disabled && primary) return colors.border;
  if (primary) return colors.brand;
  if (secondary) return colors.brandSecondary;
  if (destructive) return colors.red;
  if (subtle) return colors.brand;
  return colors.white;
};
